<template>
  <div :class="{ show: this.show != 0 }" class="alert">
    <div class="contents">
      <div class="message">
        <div v-html="msg"></div>
        <div class="wapper">
          <img
            :src="require('@/assets/img/faq/invitation_failure_alert@3x.png')"
          />
        </div>
      </div>
      <div class="buttons">
        <div class="close" @click="onClose">
          閉じる
        </div>
        <div class="store" @click="goStore">
          アップデート
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { FactoryTrack } from '@/constant/firebase'

export default {
  name: 'FAQWalkVersionCheck',
  components: {},
  props: ['show', 'onClose', 'msg'],
  data: function() {
    return {}
  },
  created() {},
  methods: {
    ...mapActions('Native', ['actionOpenWalk', 'actionRequestExternalLink']),
    ...mapActions('Analytics', ['trackEvent']),
    goStore: function() {
      this.trackEvent(FactoryTrack.createAppStore())
      if (this.show === 1) {
        this.actionRequestExternalLink(
          'https://play.google.com/store/apps/details?id=jp.co.unerry.BBCouponAppJoyfull&hl=ja'
        )
      } else {
        this.actionRequestExternalLink(
          'https://apps.apple.com/jp/app/%E3%82%B8%E3%83%A7%E3%82%A4%E3%83%95%E3%83%AB%E3%82%A2%E3%83%97%E3%83%AA/id1433877820'
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.l_button__external {
  width: 250px;
  margin: 20px auto 0;
}

.alert {
  width: 100%;
  height: 100vh;
  position: fixed;

  top: 0;
  display: none;
  &.show {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 40px;
    font-size: 4vw;
    .contents {
      background-color: white;
      border-radius: 10px;
      font-weight: bold;
      box-shadow: 0 10px 25px 0 rgba(0, 0, 0, 0.5);

      .message {
        padding: 20px 30px;
        border-bottom: 1px solid #cccccc;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;

        .wapper {
          width: 50%;
          margin-top: 20px;
          text-align: center;
          img {
            width: 100%;
          }
        }
      }
      .buttons {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 50px;
        color: #64290f;
        div {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
        }
        .store {
          text-align: center;
          padding: 10px;
          width: 50%;
        }
        .close {
          text-align: center;
          border-right: 1px solid #cccccc;
          padding: 10px;
          width: 50%;
        }
      }
    }
  }
}
</style>
